import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { NavMarker } from 'react-rhumb';
import { PageSubTitle, PageTitle } from 'pricing-pages-ui-components/semantic/PageHeader';
import { DataHubFaqs } from 'pricing-pages-ui-components/frequentlyAskedQuestions/DataHubFaqs';
import { DataHubProductIcon } from 'pricing-pages-ui-components/productIcon/DataHubProductIcons';
import { CreditsCallout } from '../../../components/common/credits-callout/CreditsCallout';
import PhoneSupportFooter from '../../components/phone-support/PhoneSupportFooter';
import { BannerSection } from '../../containers/BannerSection';
import { IntegrationsSection } from '../../containers/IntegrationsSection';
import { DataHubFeatureTable } from './DataHubFeatureTable';
import { DataHubMerchCards } from './DataHubMerchCards';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OPERATIONS_HUB_API_NAMES = ['operations-hub-starter', 'operations-hub-professional', 'operations-hub-enterprise'];
export const DataHubPage = () => {
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "DATA_HUB_PAGE",
    children: [/*#__PURE__*/_jsx(BannerSection, {
      screen: "DATA",
      apiNames: OPERATIONS_HUB_API_NAMES
    }), /*#__PURE__*/_jsxs(View, {
      textAlign: "center",
      marginBlockEnd: "800",
      children: [/*#__PURE__*/_jsxs(PageTitle, {
        "aria-level": 1,
        children: [/*#__PURE__*/_jsx(DataHubProductIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.data.pageTitle"
        })]
      }), /*#__PURE__*/_jsx(PageSubTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.data.description"
        })
      })]
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(DataHubMerchCards, {})
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(CreditsCallout, {
        navItem: "data"
      })
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(DataHubFeatureTable, {})
    }), /*#__PURE__*/_jsx(IntegrationsSection, {
      nav: "data"
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "1400",
      children: /*#__PURE__*/_jsx(DataHubFaqs, {})
    }), /*#__PURE__*/_jsx(PhoneSupportFooter, {
      phoneSourceId: "cms-footer",
      screen: "cms",
      apiName: "cms-hub-starter"
    })]
  });
};